import { useApprovalStatus } from './useApprovalStatus';

interface Input {
  projectId: string;
  folderId: string;
  fileId: string;
  fileApproved: boolean;
  canApproveAssets: boolean;
}

export type AssetApprovalKind = 'approve' | 'approved';

export interface AssetApproval {
  kind: AssetApprovalKind;
  onApprove: () => void;
  isUpdating: boolean;
  /** A missing permission, which is separate from having nothing to act on. */
  disabled: boolean;
}

/**
 * The binary approve toggle: the asset's own status, written directly.
 *
 * Only ever rendered for an asset running no approval chain. A chained asset reaches approved
 * by clearing every step and the engine sets the status itself, so a status write here would
 * put the file ahead of the chain meant to govern it. The API refuses it outright.
 */
export function useAssetApproval(input: Input): AssetApproval {
  const { projectId, folderId, fileId, fileApproved, canApproveAssets } = input;

  const binary = useApprovalStatus(projectId, folderId, fileId);

  return {
    kind: fileApproved ? 'approved' : 'approve',
    isUpdating: binary.isUpdating,
    disabled: !canApproveAssets,
    onApprove: () => binary.updateStatus(fileApproved ? 'to_review' : 'approved'),
  };
}
